module.exports = __webpack_public_path__ + "img/security-off.ad90514e.png";